import React from 'react';
import TextArea from '../../forms/TextArea';
import Preput from '../../forms/Preput';
import FormSetting from '../../layout/FormSetting';
import { QuestRoute } from '../../api/QuestRoutes';
import PageBreak from '../../layout/PageBreak';
import HamQuest from '../../api/HamQuestGiver';
import { userRoles } from '../../RoleProtected';

const Details = ({ children, ...props }) => {

    // const isAuthorized = IsAuthorized(userRoles.editProducts);

    // const Messages = () => {
    //     const [messages, fetchMessages] = GetState(QuestRoute.washClubs.messages, { loading: [] })
    //     const [assignments, fetchAssignments] = GetState(QuestRoute.washClubs.messageAssignments, { loading: {} })

    //     const updateAssignment = (id, type) => {
    //         HamQuest.put(`${QuestRoute.washClubs.messageAssignments}/${type}`, {
    //             messageId: id
    //         })
    //             .catch(ModalFactory.catch)
    //             .finally(() => fetchAssignments())
    //     }

    //     const addNewMessage = () => {
    //         const id = generateId();
    //         ModalFactory.show({
    //             id,
    //             title: 'Add New Message',
    //             body: (
    //                 <Form
    //                     inputs={{
    //                         message: '',
    //                         messageName: ''
    //                     }}
    //                     onSubmit={e => HamQuest.post(QuestRoute.washClubs.messages, e)
    //                         .then(() => {
    //                             ModalFactory.close(id);
    //                             fetchMessages();
    //                         })}
    //                 >
    //                     <Input
    //                         name='messageName'
    //                         label='Name'
    //                         required
    //                     />
    //                     <TextArea
    //                         label='Message'
    //                         name='message'
    //                         tags={['FirstName', 'LastName', 'FullName', 'PassProgram']}
    //                         required
    //                     />
    //                 </Form>
    //             )
    //         })
    //     }

    //     return (
    //         <PageBreak>
    //             <Button roles={userRoles.editProducts} onClick={addNewMessage} key={generateId()}>Add New Message</Button>
    //             <PageBreak>
    //                 {messages.length ? messages.map((e, i) => (
    //                     <Col
    //                         key={`Messaging-${i}`}
    //                     >
    //                         <Row wrap>
    //                             <Checkbox
    //                                 label='Use on Kiosk Display'
    //                                 checked={assignments.displayMessageId === e.messageId}
    //                                 onClick={(f) => {
    //                                     if (!isAuthorized) return;
    //                                     f.preventDefault();
    //                                     const id = assignments.displayMessageId === e.messageId ? null : e.messageId;
    //                                     updateAssignment(id, 'kiosk');
    //                                 }}
    //                                 readOnly
    //                                 standalone
    //                                 disabled={!isAuthorized}
    //                             />
    //                             <Checkbox
    //                                 label='Use on Receipt Footer'
    //                                 checked={assignments.receiptMessageId === e.messageId}
    //                                 onClick={(f) => {
    //                                     if (!isAuthorized) return;
    //                                     f.preventDefault();
    //                                     const id = assignments.receiptMessageId === e.messageId ? null : e.messageId;
    //                                     updateAssignment(id, 'receipt');
    //                                 }}
    //                                 standalone
    //                                 disabled={!isAuthorized}
    //                             />
    //                         </Row>
    //                         <Form
    //                             inputs={{
    //                                 message: e.message,
    //                                 messageName: e.messageName
    //                             }}
    //                             onSubmit={(f) => HamQuest.put(QuestRoute.washClubs.message(e.messageId), f)
    //                                 .then(() => fetchMessages())}
    //                             editable
    //                             roles={userRoles.editProducts}

    //                             formControls={[
    //                                 <Button
    //                                     label='Delete Message'
    //                                     roles={userRoles.editProducts}
    //                                     onClick={() => ModalFactory.confirmAndProcess({
    //                                         confirmation: {
    //                                             title: 'Are you sure?',
    //                                             body: 'Are you sure you want to delete this message?',
    //                                             type: 'warning',
    //                                         },
    //                                         promise: {
    //                                             title: 'Removing Message',
    //                                             callback: () => HamQuest.delete(QuestRoute.washClubs.message(e.messageId))
    //                                         },
    //                                         confirmed: {
    //                                             title: 'Message Deleted',
    //                                             type: 'success',
    //                                         },
    //                                         finally: () => fetchMessages()
    //                                     })}
    //                                 />
    //                             ]}
    //                         >
    //                             <Input
    //                                 name='messageName'
    //                                 label='Name'
    //                                 required
    //                             />
    //                             <TextArea
    //                                 label='Message'
    //                                 name='message'
    //                                 tags={['FirstName', 'LastName', 'FullName', 'PassProgram']}
    //                                 required
    //                             />
    //                         </Form>
    //                     </Col>
    //                 )) : <div>Loading Messages<LoadingEllipsis /></div>}
    //             </PageBreak>
    //         </PageBreak>
    //     )
    // }

    return (
        <PageBreak>
            <FormSetting
                label='Details'
                info='The content that displays on the Wash Club landing page for users not currently enrolled. Typically used to explain how the program works.'
                getInputs={QuestRoute.washClubs.details}
                onSubmit={e => HamQuest.put(QuestRoute.washClubs.details, { value: e.details })}
                text='Update'
                editable
                roles={userRoles.editProducts}
            >
                <TextArea
                    name='details'
                    // tags={['FirstName', 'LastName']}
                    required
                />
            </FormSetting>

            <FormSetting
                label='Terms and Conditions'
                getInputs={QuestRoute.washClubs.terms}
                onSubmit={e => {
                    if (e.terms === '<p><br></p>') e.terms = '';
                    if (e.lprTerms === '<p><br></p>') e.lprTerms = '';
                    if (e.rfidTerms === '<p><br></p>') e.rfidTerms = '';

                    return HamQuest.put(QuestRoute.washClubs.terms, { ...e })
                }}
                text='Update'
                editable
                // hidden
                roles={userRoles.editProducts}
            >
                <Preput
                    label='Wash Club'
                    name='terms'
                    required
                />
                <Preput
                    label='LPR'
                    name='lprTerms'
                    required
                />
                <Preput
                    label='RFID'
                    name='rfidTerms'
                    required
                />
            </FormSetting>

            <FormSetting
                label='Sign Up Completion'
                info='When a user completes a signup, you can display custom messages. This could be instructional, or a simple thank you message.'
                getInputs={QuestRoute.washClubs.signupMessages}
                onSubmit={e => {
                    if (e.lprSignupReceiptMessage === '<p><br></p>') e.lprSignupReceiptMessage = '';
                    if (e.signupCompleteMessage === '<p><br></p>') e.signupCompleteMessage = '';
                    if (e.rfidSignupReceiptMessage === '<p><br></p>') e.rfidSignupReceiptMessage = '';

                    return HamQuest.put(QuestRoute.washClubs.signupMessages, { ...e })
                }}

                text='Update'
                editable
                roles={userRoles.editProducts}
            >
                <Preput
                    label='Signup Complete App Message'
                    name='signupCompleteMessage'
                    required
                />
                <Preput
                    label='LPR Signup Receipt Message'
                    name='lprSignupReceiptMessage'
                    required
                />
                <Preput
                    label='RFID Signup Receipt Message'
                    name='rfidSignupReceiptMessage'
                    required
                />

            </FormSetting>
        </PageBreak>
    );
}

export default Details;
